import { render, staticRenderFns } from "./RegulationPanel.vue?vue&type=template&id=4c4307f0&"
import script from "./RegulationPanel.vue?vue&type=script&lang=js&"
export * from "./RegulationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports